import { HttpClinet } from './../utils/config'

export const authAPI = {
    Login: (data) => {
        return HttpClinet({
            url: `/auth/login`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    ForgetPassword: (data) => {
        return HttpClinet({
            url: `/auth/forgetPassword`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    ForgetPasswordByID: (_id) => {
        return HttpClinet({
            url: `/auth/forgetPassword/${_id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    ResetPassword: (data) => {
        return HttpClinet({
            url: `/auth/ResetPassword`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    GetUser: () => {
        return HttpClinet({
            url: `/auth/getUser`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    updateEmail: (email) => {
        return HttpClinet({
            url: `/auth/updateEmail`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            data: { email }
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    getPrefix: () => {
        return HttpClinet({
            url: `/prefix/getPrefix`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    getPrefixAdmin: () => {
        return HttpClinet({
            url: `/prefix/getPrefixAdmin`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    createPrefix: (data) => {
        return HttpClinet({
            url: `/prefix/createPrefix`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    editUser: (data) => {
        return HttpClinet({
            url: `/auth/editUser`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/form-data',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    updateStatus: (data) => {
        return HttpClinet({
            url: `/prefix/updateStatus`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    getPrefixByID: (_id) => {
        return HttpClinet({
            url: `/prefix/getPrefixByID/${_id}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    editPrefix: (data) => {
        return HttpClinet({
            url: `/prefix/editPrefix`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
    userDetail: (username) => {
        return HttpClinet({
            url: `/auth/userDetail/${username}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                throw error
            })
    },
}